import { z } from 'zod/v4';

export const copilotRequestActionSchema = z.object({
  actionId: z.number().min(1),
  action: z.string(),
});

export type CopilotRequestAction = z.infer<typeof copilotRequestActionSchema>;
